import React, { useState, useEffect  } from "react"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { isEmpty, map, size } from "lodash"
import { Card, CardBody, Col, Container, Row, Table, CardImg,CardTitle,CardText } from "reactstrap"
import * as moment from "moment"
import { ToWords } from 'to-words'
import { getStoreSettings as onGetStoreSettings } from "store/products/actions"
import { useSelector, useDispatch } from "react-redux";

const toWords = new ToWords({
  localeCode: 'en-IN',
  converterOptions: {
    currency: true,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
  }
});

const InvoiceDetailA5L = React.forwardRef((props, ref) => {
  const [salesDetails, setSalesDetails] = useState()
  const [storeDetails, setStoreDetails] = useState()
  const [customerDetails, setCustomerDetails] = useState()
  const [defaultFootNote, setDefaultFootNote] = useState('')
  const [settings, setSettings] = useState()

 
  useEffect(() => {
    if(settings && settings.length > 0){
      const defaultFootNote = settings.filter(each => each.settingid == 'DEFAULT_RECEIPT_FOOTNOTE')
      if(defaultFootNote && defaultFootNote.length > 0){
        const defaultFootNoteValue = defaultFootNote[0].settingvalue
        setDefaultFootNote(defaultFootNoteValue)
      }
    }
  }, [settings]);

  useEffect(() => {
      setSalesDetails(props.salesDetails)
      setStoreDetails(props.storeDetails)
      setCustomerDetails(props.customerDetails)
      setSettings(props.settings)
  }, [props])

  function isNonZeroNumber(num){
    if(Number(num) && Number(num) != 0){
      return true;
    }
    else{
      return false;
    }
  }

  return (
    <React.Fragment>
      <div className="a5-landscape pt-2" id="invoice-detail-toprint" ref={ref}>
        <Container fluid>
        {!isEmpty(salesDetails) && !isEmpty(storeDetails) && (
          <Row className="p-2 pb-0">
            <Col lg="12" className="pb-0 mb-0">
              <Table className="table-sm mb-0 pb-0 font-size-12 fw-medium no-page-break border-ash">
                <tbody>
                  <tr>
                    <td className="pb-0">
                      <div className="font-size-13"><strong>{storeDetails.storename}</strong></div>
                      {storeDetails && storeDetails.storeaddress && storeDetails.storeaddress != '' && 
                        <div>{storeDetails.storeaddress}</div>
                      }
                      { (storeDetails && storeDetails.storecity && storeDetails.storecity != '') ? storeDetails.storecity + " - " : "" }
                      { (storeDetails && storeDetails.storepostalcode && storeDetails.storepostalcode != '') ? storeDetails.storepostalcode : "" }
                      { (storeDetails && storeDetails.storestate && storeDetails.storestate != '') ? ", "+storeDetails.storestate : "" }
                      { (storeDetails && storeDetails.storecountry && storeDetails.storecountry != '') ? ", "+storeDetails.storecountry : "" }

                      {storeDetails && storeDetails.storemobile && storeDetails.storemobile != '' && 
                        <div>{"Mob: "}{storeDetails.storemobile}{", Phone: "}{storeDetails.storephone}
                        </div>
                      }
                      {storeDetails && storeDetails.storeemail && storeDetails.storeemail != '' && <div>
                          {"Email: "}{storeDetails.storeemail}
                      </div>}
                      {storeDetails && storeDetails.storegstin && storeDetails.storegstin != '' && <div>
                          {"GSTIN: "}{storeDetails.storegstin}
                          <div>
                            <span className="">State : Kerala</span>
                            <span className="ms-2">Code : 32</span>
                          </div>
                      </div>
                      }
                    </td>
                    <td className="pb-0">
                      <address>
                        Billed To
                        <br />
                        <span className="ms-1"><strong>{customerDetails?.name}</strong></span><br/>
                        {customerDetails && customerDetails.address && customerDetails.address != '' ? <div className="ms-1">{customerDetails.address}</div>: ''}
                        {customerDetails && customerDetails.mobile && customerDetails.mobile != '' ? <div className="ms-1">{customerDetails.mobile}</div>: ''}
                        {customerDetails && customerDetails.phone && customerDetails.phone != '' ? <div className="ms-1">{customerDetails.phone}</div>: ''}
                        {customerDetails && customerDetails.email && customerDetails.email != '' ? <div className="ms-1">{customerDetails.email}</div>: ''}
                        {customerDetails && customerDetails.gstin && customerDetails.gstin != '' ? <div className="ms-1">{"GSTIN: "}{customerDetails.gstin}</div>: ''}
                        {customerDetails && customerDetails.statename && customerDetails.statename != '' ? <div className="ms-1">{"State: "}{customerDetails.statename}{", Code: "}{customerDetails.statecode}</div>: ''}
                      </address>
                    </td>
                    <td className="pb-0">
                      <div className="float-end">
                        {storeDetails && storeDetails.storelogo && storeDetails.storelogo != '' && 
                          <CardImg className="img-fluid logo-md" src={storeDetails.storelogo} alt="logo" />
                          
                        }
                        <div className="font-size-12 mt-2">
                          Inv No. : {salesDetails.invoiceno}
                        </div>
                        <div>
                          Date : {salesDetails.invoicedate && moment(new Date(salesDetails.invoicedate)).format("DD-MMM-YYYY, HH:mm ")}
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
              {/*<div className="py-1 mt-0">
                <h3 className="font-size-12 fw-bold mb-0">Summary</h3>
              </div>*/}
                <Table className="table-nowrap border-ash table-sm no-bottom-margin fw-medium min-height-a5 ">
                  <thead className="table-light font-size-12 border-ash">
                    <tr className="py-0 border-ash-bottom ">
                      <th className="text-center border-ash-bottom" style={{ width: "3%" }}>No.</th>
                      <th className="border-ash-bottom" style={{ width: "52%" }}>Item</th>
                      <th className="border-ash-bottom" style={{ width: "5%" }}>HSN</th>
                      <th className="border-ash-bottom" style={{ width: "10%" }}>Rate & Qty </th>
                      <th className="border-ash-bottom" style={{ width: "10%" }}>Price</th>
                      <th className="border-ash-bottom" style={{ width: "5%" }}>GST</th>
                      <th style={{ width: "10%" }} className="text-end border-ash-bottom">Total</th>
                    </tr>
                  </thead>
                  <tbody className="">
                    {map(
                      salesDetails.salesRows,
                      (item, key) => (
                        item.productid != '' && <tr key={key} className="font-size-12">
                          <td className="r-cell text-center">{key+1}</td>
                          <td className="text-wrap r-cell">
                            {item.justproductname? item.justproductname : item.productname}
                          </td>
                          <td className="r-cell">{item.hsncode}</td>
                          <td className="r-cell">{Number(item.productrate).toLocaleString('en-IN',{minimumFractionDigits: 2})} × {item.productqty} <span className="text-muted font-size-10 ms-0">{item.selectedunitname}</span> </td>
                          <td className="r-cell">
                            {Number(item.productgrosswithouttax).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                            {Number(item.productdisc) > 0 && <span className="font-size-10"><br/>-Disc {Number(item.productdisc).toLocaleString('en-IN',{minimumFractionDigits: 2})}</span>}
                          </td>
                          <td className="r-cell">{Number(item.productgst).toLocaleString('en-IN',{minimumFractionDigits: 2})}<span className="font-size-9">({item.gstpercentage}%)</span></td>
                          <td className="text-end r-cell">{Number(item.producttotal).toLocaleString('en-IN',{minimumFractionDigits: 2})}</td>
                        </tr>
                      )
                    )}
                    </tbody>
                    <tfoot className="py-1 fw-bold font-size-11">
                      <tr>
                        <td></td>
                        <td className="text-wrap text-end">
                          Total
                        </td>
                        <td></td>
                        <td></td>
                        <td>
                          {Number(Number(salesDetails.totalgrosswithouttax)-Number(salesDetails.totaldisc)).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                        </td>
                        <td>{Number(salesDetails.totalgst).toLocaleString('en-IN',{minimumFractionDigits: 2})}</td>
                        <td className="text-end">{Number(salesDetails.totaltotal).toLocaleString('en-IN',{minimumFractionDigits: 2})}</td>
                      </tr>
                    </tfoot>
                </Table>
                <div className="no-page-break">
                <Table className="table-nowrap border-ash table-sm no-bottom-margin fw-medium no-page-break">
                  <tbody>
                    <tr>
                      <td style={{ maxWidth: "30%" }}>
                        <Table className="table-nowrap border-ash table-sm no-bottom-margin table-nopadd font-size-11 fw-medium">
                          <tbody>
                            <tr>
                              <td colSpan="3" className="text-center table-light border-ash-bottom">
                                SGST Breakup
                              </td>
                            </tr>
                            <tr className="text-center">
                              <td className="">
                                Rate
                              </td>
                              <td className="">
                                Taxable Amt
                              </td>
                              <td className="">
                                Tax
                              </td>
                            </tr>
                          {map(
                            salesDetails.sgstArray,
                            (item, key) => (
                              <tr key={key} className="text-center">
                                <td className="">
                                {item.tax}%
                                </td>
                                <td className="">
                                {Number(item.taxableamount).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                                </td>
                                <td className="">
                                {Number(item.taxamount).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                                </td>
                              </tr>
                              )
                            )}
                          </tbody>
                        </Table>
                      </td>
                      <td style={{ maxWidth: "30%" }}>
                        <Table className="table-nowrap border-ash table-sm no-bottom-margin table-nopadd font-size-11 fw-medium">
                          <tbody>
                          <tr>
                              <td colSpan="3" className="text-center table-light border-ash-bottom">
                                CGST Breakup
                              </td>
                            </tr>
                            <tr className="text-center">
                              <td className="">
                                Rate
                              </td>
                              <td className="">
                                Taxable Amt
                              </td>
                              <td className="">
                                Tax
                              </td>
                            </tr>
                          {map(
                            salesDetails.cgstArray,
                            (item, key) => (
                              <tr key={key} className="text-center">
                                <td className="">
                                {item.tax}%
                                </td>
                                <td className="">
                                {Number(item.taxableamount).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                                </td>
                                <td className="">
                                {Number(item.taxamount).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                                </td>
                              </tr>
                              )
                            )}
                          </tbody>
                        </Table>
                      </td>
                      {size(salesDetails.igstArray) > 0 && 
                      <td style={{ maxWidth: "30%" }}>
                      <Table className="table-nowrap border-ash table-sm no-bottom-margin table-nopadd fw-medium">
                          <tbody>
                          <tr>
                              <td colSpan="3" className="text-center font-size-11 table-light border-ash-bottom">
                                IGST Breakup
                              </td>
                            </tr>
                            <tr className="text-center">
                              <td className="">
                                Rate
                              </td>
                              <td className="">
                                Taxable Amt
                              </td>
                              <td className="">
                                Tax
                              </td>
                            </tr>
                          {map(
                            salesDetails.igstArray,
                            (item, key) => (
                              <tr key={key} className="text-center">
                                <td className="">
                                {item.tax}%
                                </td>
                                <td className="">
                                {Number(item.taxableamount).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                                </td>
                                <td className="">
                                {Number(item.taxamount).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                                </td>
                              </tr>
                              )
                            )}
                          </tbody>
                        </Table>
                      </td>}
                      <td style={{ maxWidth: "40%" }}>
                      <Table className="table-nowrap border-ash table-sm no-bottom-margin font-size-12 fw-medium">
                        <tbody>
                          {isNonZeroNumber(salesDetails.loadingcharges) &&
                          <tr>
                            <td className="py-0" style={{ width: "5%" }}></td>
                            <td className="py-0" style={{ width: "35%" }}></td>
                            <td style={{ width: "30%" }} className="text-end py-0">
                              Loading Charges
                            </td>
                            <td style={{ width: "30%" }} className="text-end py-0">
                              {Number(salesDetails.loadingcharges).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                            </td>
                          </tr>
                          }
                          {isNonZeroNumber(salesDetails.othercharges) &&
                          <tr>
                            <td className="py-0" style={{ width: "5%" }}></td>
                            <td className="py-0" style={{ width: "35%" }}></td>
                            <td style={{ width: "30%" }} className="text-end py-0">
                              Other Charges
                            </td>
                            <td style={{ width: "30%" }} className="text-end py-0">
                              {Number(salesDetails.othercharges).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                            </td>
                          </tr>
                          }
                          {isNonZeroNumber(salesDetails.otherexpences) &&
                          <tr>
                            <td className="py-0" style={{ width: "5%" }}></td>
                            <td className="py-0" style={{ width: "35%" }}></td>
                            <td style={{ width: "30%" }} className="text-end py-0">
                              Other Expenses
                            </td>
                            <td style={{ width: "30%" }} className="text-end py-0">
                              {Number(salesDetails.otherexpences).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                            </td>
                          </tr>
                          }
                          {isNonZeroNumber(salesDetails.discounts) &&
                          <tr>
                            <td className="py-0" style={{ width: "5%" }}></td>
                            <td className="py-0" style={{ width: "35%" }}></td>
                            <td style={{ width: "30%" }} className="text-end font-size-14 py-0">
                            <strong>Discounts</strong>
                            </td>
                            <td style={{ width: "30%" }} className="text-end font-size-14 py-0">
                            <strong>{Number(salesDetails.discounts).toLocaleString('en-IN',{minimumFractionDigits: 2})}</strong>
                            </td>
                          </tr>
                          }
                          {isNonZeroNumber(salesDetails.roundoff) &&
                          <tr>
                            <td className="py-0" style={{ width: "5%" }}></td>
                            <td className="py-0" style={{ width: "35%" }}></td>
                            <td style={{ width: "30%" }} className="text-end py-0">
                              Round Off
                            </td>
                            <td style={{ width: "30%" }} className="text-end py-0">
                              {Number(salesDetails.roundoff).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                            </td>
                          </tr>
                          }
                          <tr className="pt-3">
                            <td className="py-2 mt-3" style={{ width: "5%" }}></td>
                            <td className="py-2" style={{ width: "35%" }}></td>
                            <td className="text-end font-size-12 py-2" style={{ width: "30%" }} >
                            <strong>Grand Total (INR)</strong>
                            </td>
                            <td style={{ width: "30%" }} className="text-end font-size-13 py-2">
                              <strong>{Number(salesDetails.grandtotal).toLocaleString('en-IN',{minimumFractionDigits: 2})}</strong>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                      </td>
                    </tr>
                  </tbody>
                </Table>
                <Table className="table-nowrap border-ash table-sm font-size-12 fw-medium no-page-break">
                  <tbody>
                    {isNonZeroNumber(salesDetails.cashreceived) &&
                    <tr>
                      <td className="py-0" style={{ width: "5%" }}></td>
                      <td className="text-wrap py-0">
                        Amount Received (INR)
                      </td>
                      <td className="text-wrap py-0" colSpan="2" >
                        {Number(salesDetails.cashreceived).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                        {" "}<span className=" ">({toWords.convert(salesDetails.cashreceived)})</span>
                      </td>
                    </tr>
                    }
                    {isNonZeroNumber(salesDetails.writeoff) &&
                    <tr>
                      <td className="py-0" style={{ width: "5%" }}></td>
                      <td className="text-wrap ">
                        Write Off(INR)
                      </td>
                      <td className="text-wrap py-0" colSpan="2" >
                        {Number(salesDetails.writeoff).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                        {" "}<span className=" ">({toWords.convert(salesDetails.writeoff)})</span>
                      </td>
                    </tr>
                    }
                    {isNonZeroNumber(salesDetails.balanceamount) &&
                    <tr>
                      <td className="py-0" style={{ width: "5%" }}></td>
                      <td className="text-wrap py-0">
                        Balance Amount (INR)
                      </td>
                      <td className="text-wrap py-0" colSpan="2" >
                        {Number(salesDetails.balanceamount).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                      </td>
                    </tr>
                    }
                    <tr>
                      <td className="py-0" style={{ width: "5%" }}></td>
                      <td className="py-0" style={{ width: "35%" }}></td>
                      <td colSpan="2" className="text-end py-0">
                        For <span className=""> {storeDetails.storename}  </span><br/>
                        <div className="pt-3">Authorised Signatory</div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2" className="text-wrap py-0">
                        E & O.E
                      </td>
                      <td colSpan="2" className="text-end py-0">
                        Thank you
                      </td>
                    </tr>
                    {defaultFootNote && defaultFootNote != '' && <tr className="">
                      <td colSpan="4" className="text-wrap text-center pb-2">
                        <small>{defaultFootNote}</small>
                      </td>
                    </tr>}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        )}
        </Container>
      </div>
    </React.Fragment>
  )
});

export default InvoiceDetailA5L
